import React from "react";
import { render } from "react-dom";

import { Provider } from "react-redux";
import store from "../store";

// Expose store to the outside world
// Our jQuery code can just call window.store.dispatch({ type: 'ACTION_TYPE', whatever: data, goes: here })
window.store = store;

// Remove the old store, we don't need to keep this around
if (localStorage && localStorage.removeItem) {
    localStorage.removeItem("redux-1");
}

/* eslint-disable no-unused-vars */
// Need to run the actionCreators to set up our top.RDX, which exposes the action creators to the outside word
import * as actionCreators from "../actions/actionCreators";
import * as audienceFolderActions from "../actions/audienceFolderActions";
import * as sessionActions from "../actions/sessionActions";
import * as flowActions from "../actions/flowActions";
import * as notifyActions from "../actions/notifyActions";

// Styles / CSS / Stylus
import css from "../styles/style.styl";

import "scrolling-element"; // polyfill for document.scrollingElement, needed in IE by react-dnd-scrollzone w/ customizations
/* eslint-enable no-unused-vars */

import _ from "lodash";
top._ = _;
/* We should eventually remove setting lodash on top.
It's used here: Layouts\Access.cshtml
AE\AE.js
 - universeValueToHtml, used in the audience insights page
AE\AE.Push.js
Possibly more.  AI needs to be written in react, then we can kill jstree and some of these.
*/

////// ALL PAGES /////////////

//import AllModals from '../components/modals/AllModals';
import Loadable from "react-loadable";
// import ReactGA from "react-ga";
// ReactGA.initialize('UA-239306450-2');
// ReactGA.pageview(window.location.pathname + window.location.search);
const BlankLoader = () => <span />;
const AllModals = Loadable({
    loader: () => import("../components/modals/AllModals"),
    loading: BlankLoader,
});
import GlobalAjaxLoadingIndicator from "../components/GlobalAjaxLoadingIndicator";

import dragDropWithScrollContext from "../helpers/dragDropWithScrollContext";
const AllModalsC = dragDropWithScrollContext(AllModals);

if (document.getElementById("react_layout_modals")) {
    const modals = (
        <Provider store={store}>
            <div>
                <AllModalsC />
                <GlobalAjaxLoadingIndicator />
            </div>
        </Provider>
    );
    render(modals, document.getElementById("react_layout_modals"));
}

import NotifyList from "../components/notify/NotifyList";
if (document.getElementById("react_notify")) {
    const nl = (
        <Provider store={store}>
            <NotifyList />
        </Provider>
    );
    render(nl, document.getElementById("react_notify"));
}

import AeLocalNav from "../components/nav/AeLocalNav";
if (document.getElementById("ae_local_nav")) {
    const localNav = (
        <Provider store={store}>
            <AeLocalNav />
        </Provider>
    );
    render(localNav, document.getElementById("ae_local_nav"));
}

import SaasHeader from "../components/nav/SaasHeader";
if (document.getElementById("ae_saasheader_nav")) {
    const localNav = (
        <Provider store={store}>
            <SaasHeader />
        </Provider>
    );
    render(localNav, document.getElementById("ae_saasheader_nav"));
}

import LeftNavigation from "../components/nav/LeftNavigation";
if (document.getElementById("ae_left_nav")) {
    const noLeftNavPages = ["/account/login", "/account/resetpassword", "/account/forgotpassword"];
    const pathname = window.location.pathname;

    if (!noLeftNavPages.some(path => pathname && pathname.toLowerCase().includes(path))) {
        const leftNav = (
            <Provider store={store}>
                <LeftNavigation />
            </Provider>
        );
        render(leftNav, document.getElementById("ae_left_nav"));
    }
}

window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
        const start = Date.now();
        return setTimeout(() => {
            cb({
                didTimeout: false,
                timeRemaining() {
                    return Math.max(0, 50 - (Date.now() - start));
                },
            });
        }, 1);
    };

window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
        clearTimeout(id);
    };

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */
window.matchMedia ||
    (window.matchMedia = (function () {
        "use strict";

        // For browsers that support matchMedium api such as IE 9 and webkit
        let styleMedia = window.styleMedia || window.media;

        // For those that don't support matchMedium
        if (!styleMedia) {
            let style = document.createElement("style"),
                script = document.getElementsByTagName("script")[0],
                info = null;

            style.type = "text/css";
            style.id = "matchmediajs-test";

            if (!script) {
                document.head.appendChild(style);
            } else {
                script.parentNode.insertBefore(style, script);
            }

            // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
            info = ("getComputedStyle" in window && window.getComputedStyle(style, null)) || style.currentStyle;

            styleMedia = {
                matchMedium(media) {
                    const text = "@media " + media + "{ #matchmediajs-test { width: 1px; } }";

                    // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                    if (style.styleSheet) {
                        style.styleSheet.cssText = text;
                    } else {
                        style.textContent = text;
                    }

                    // Test if media query is true or false
                    return info.width === "1px";
                },
            };
        }

        return function (media) {
            return {
                matches: styleMedia.matchMedium(media || "all"),
                media: media || "all",
            };
        };
    })());
